// importing require modules
import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
const TamplateOne = lazy(() => import("../views/TamplateOne"));
const TamplateTwo = lazy(() => import("../views/TamplateTwo"));

export default function routes() {
  return (
    // Prevent loading errors with fallback Loader
    <Suspense>
      {/* Route configuration */}
      <Routes>
        {/* Route for homepage */}
        <Route path="/" element={<TamplateOne />} />
        <Route path="1" element={<TamplateTwo />} />

        {/* End Of Route configuration */}
      </Routes>
    </Suspense>
  );
}
